import { IMultiStateSwitch } from './types';
import { Button } from 'baseui/button';
import { ButtonGroup, MODE, SIZE } from "baseui/button-group";
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { Notification, KIND } from "baseui/notification";
import { FormattedMessage, useIntl } from 'react-intl';
import { Banner } from "baseui/banner";

export interface ButtonsPanelProps extends IMultiStateSwitch
{
    buttonSize?: typeof SIZE[keyof typeof SIZE],
}

export const ButtonsPanel = (props: ButtonsPanelProps) => {
    const [actState, setActState] = useSetObjectValue(props.id, props.resourceGroupId, "actState", props.actState, 0);
    const [resetMan, setResetMan] = useSetObjectValue(props.id, props.resourceGroupId, "resetMan", props.resetMan, 0);
    const arr = props.stateTextList ? JSON.parse(props.stateTextList) : [];
    const intl = useIntl();

    const onValueChangedState = (e: any, index: number) => { e.stopPropagation();  e.preventDefault();  setActState(index + 1); };
    const resetManMode = (e: any) =>  { e.stopPropagation();  e.preventDefault();  setResetMan(true) };

    const noStateList = !props.stateTextList || props.stateTextList?.length <= 4;
    const errorState = (actState <= 0 || actState >= arr?.length + 1) && !noStateList;

    return (

        <>
            {noStateList && (
                <Notification kind={KIND.warning}>
                    <FormattedMessage id='MultiStateSwitch.StateList' defaultMessage="The list of states is wrong or empty. Therefore, no input options will be created." />
                </Notification>
            )}
            {errorState && (
                <Notification kind={KIND.warning}>
                    <FormattedMessage id='MultiStateSwitch.StateSelected' defaultMessage="Incorrect state selected. Therefore, no input options will be activated." />
                </Notification>
            )}

            {arr && arr.length > 0 &&
                <ButtonGroup
                    size={props.buttonSize}
                    mode={MODE.radio}
                    selected={actState - 1}
                    onClick={onValueChangedState}
                    overrides={{
                        Root: {
                            style: ({ $theme }) => ({
                                flexWrap: 'wrap',
                                rowGap: $theme.sizing.scale200
                            })
                        }
                    }}
                >
                    {arr.map((item: string, index: number) => (
                        <Button key={index}  overrides={{
                            BaseButton: {
                              style: ({
                                $theme,
                                $isSelected,
                              }) => ({
                                backgroundColor: $isSelected ? $theme.colors.accent : $theme.colors.buttonSecondaryFill
                              })
                            }
                          }}>{item}</Button>
                    ))}
                </ButtonGroup>}
            {props.isMan && (
                <Banner
                    action={{
                        label: intl.formatMessage({ id: "MultiStateSwitch.ManReset", defaultMessage: "Reset" }),
                        onClick: resetManMode,
                    }}
                >
                    <FormattedMessage id='MultiStateSwitch.IsMan' defaultMessage="The value is overwritten manually" />
                </Banner>
            )}
        </>

    );
};
